"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
// default language
var lng = 'fi';
var resources = {
    fi: {
        translation: __assign({}, seesignage_utils_1.fiCommonTranslations)
    },
    sv: {
        translation: __assign({}, seesignage_utils_1.svCommonTranslations)
    }
};
// create own instance for seesignage-player-utils translations.
var i18nInstance = i18next_1.default.createInstance();
i18nInstance.init({
    resources: resources,
    lng: lng,
    interpolation: {
        escapeValue: false
    },
    react: {
        useSuspense: true
    }
});
exports.default = i18nInstance;
//# sourceMappingURL=i18n.js.map